import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=58b47685&"
import script from "./layout.vue?vue&type=script&lang=js&"
export * from "./layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58b47685')) {
      api.createRecord('58b47685', component.options)
    } else {
      api.reload('58b47685', component.options)
    }
    module.hot.accept("./layout.vue?vue&type=template&id=58b47685&", function () {
      api.rerender('58b47685', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/layout.vue"
export default component.exports